import React, { useState } from "react";

import Swal from 'sweetalert2'

const SelectColumns = ({setShowSelectColumns, handleChangeColumnsVisible, columns, saveColumnsPreferences = () => console.log("Save Columns Preferences"), usuario, columnsName=""}) =>{
    
    const handleSaveColumnsPreferences = async () => {
        if(columnsName != ""){
            let columnsToSave = columns.filter(c => c.visible)
            columnsToSave = columnsToSave.map(c => c.property);

            let preferencesToSave = {
                userName: usuario.userName,
                userId: usuario._id,
                [`columnas${columnsName}`]: columnsToSave
            }

            let res = await saveColumnsPreferences(preferencesToSave);

            if(res)  Swal.fire({
                title: 'Preferencias guardadas exitosamente!',
                icon: 'success'
            }) 
            else Swal.fire({
                title: 'Ocurrio un error!',
                icon: 'error'
            })

            setShowSelectColumns(false)
        }

    }

    const handleCheckColumns = () => {
        if(columns.some(c => !c.visible)){
            let similCheck =  {target:{checked:true}};
            columns.forEach((c,i) => handleChangeColumnsVisible(similCheck, c, i));
        }else{
            let similCheck =  {target:{checked:false}};
            columns.forEach((c,i) => handleChangeColumnsVisible(similCheck, c, i));
        }
    }

    return <div className="modalContainer">
    <div className="selectColumnsDiv">
        <h3 className="headerDiv">Seleccionar Columnas</h3>
        <button className="minimizarBtn" onClick={()=>setShowSelectColumns(false)}>X</button>
        {columns.map((c,i) => <div className="selectableColumnsDiv">
            <label>
                <input type="checkbox" checked={c.visible} value={c.visible} name={c.property} onChange={(e)=>handleChangeColumnsVisible(e, c, i)}/>
                <span className="custom-checkbox"/>
                {c.title}
            </label>
        </div>)}
        <div className="savePreferencesContainer">
            <div className="innerContainer">
                <button onClick={handleSaveColumnsPreferences} className="savePreferencesBtn">GUARDAR SELECCIÓN PARA {usuario.userName}</button>
                <button className="selectAllColumnsBtn" onClick={handleCheckColumns}>{columns.some(c => !c.visible) ? 'tildar todas' : 'destildar todas'}</button>
            </div>
        </div>
    </div>
</div>

}

export default SelectColumns;